import gitlab from './gitlab';

function init() {
   window.removeEventListener('error', listen);
   window.addEventListener('error', listen);
}

function listen(e) {
   if (!window.navigator.onLine) return; // we're offline
   if (window.location.search.includes('debug')) return; // we're debugging

   const title = e.message || 'JavaScript-Fehler erkannt';
   const stacktrace = `\`\`\`\n${e.error ? e.error.stack.toString() : 'kein Stacktrace'}\n\`\`\``;
   const appendix = {
      errorType: e.type,
      errorPath: e.filename,
      errorLine: `${e.lineno}:${e.colno}`,
   };

   gitlab.openIssue(title, stacktrace, appendix);
}

export default { init };
